/**
 * decor.ts — Fundo decorativo e acabamento de borda em TODO bloco
 *
 * Acrescenta ao catálogo pronto as propriedades avançadas de fundo (degradê em
 * malha, aurora, grade técnica, pontilhado...) e de acabamento de borda (onda,
 * diagonal, arco, montanha, zigue-zague), sem lista duplicada: qualquer bloco
 * novo passa a ter as mesmas opções assim que este módulo é importado.
 *
 * Segue o mesmo caminho de `screen.ts` — aplicado sobre os blocos já
 * registrados, sempre a partir de `src/lib/studio/core/index.ts`.
 *
 * RELEASE: v1.0.0 - 2026-09-11 - Versão inicial (biblioteca própria, Fase 1)
 */

import { listBlocks, registerBlock } from '../blockRegistry';
import {
  STUDIO_BACKGROUND_OPTIONS,
  STUDIO_DIVIDER_HEIGHT_OPTIONS,
  STUDIO_DIVIDER_OPTIONS,
} from '../decor';
import type { StudioBlockProp } from '../types';

/** Propriedades acrescentadas a todos os blocos. */
export const PROPRIEDADES_DE_DECORACAO: StudioBlockProp[] = [
  {
    key: 'background',
    label: 'Fundo decorativo',
    type: 'select',
    defaultValue: 'none',
    advanced: true,
    options: STUDIO_BACKGROUND_OPTIONS,
    help: 'Desenho de fundo pronto do sistema. Não usa imagem e não usa script.',
  },
  {
    key: 'backgroundFrom',
    label: 'Cor 1 do fundo',
    type: 'color',
    advanced: true,
    help: 'Cor principal usada pelo fundo decorativo.',
  },
  {
    key: 'backgroundTo',
    label: 'Cor 2 do fundo',
    type: 'color',
    advanced: true,
    help: 'Cor secundária do degradê, da malha ou da aurora.',
  },
  {
    key: 'backgroundBase',
    label: 'Cor de base do fundo',
    type: 'color',
    advanced: true,
    help: 'Cor sólida por baixo do desenho (normalmente escura nas capas).',
  },
  {
    key: 'dividerTop',
    label: 'Acabamento no topo',
    type: 'select',
    defaultValue: 'none',
    advanced: true,
    options: STUDIO_DIVIDER_OPTIONS,
    help: 'Recorte na borda de cima da faixa (onda, diagonal, arco...).',
  },
  {
    key: 'dividerBottom',
    label: 'Acabamento na base',
    type: 'select',
    defaultValue: 'none',
    advanced: true,
    options: STUDIO_DIVIDER_OPTIONS,
    help: 'Recorte na borda de baixo da faixa.',
  },
  {
    key: 'dividerColor',
    label: 'Cor do acabamento',
    type: 'color',
    advanced: true,
    help: 'Normalmente é a cor da faixa vizinha, para dar a impressão de recorte.',
  },
  {
    key: 'dividerHeight',
    label: 'Altura do acabamento',
    type: 'select',
    defaultValue: 'md',
    advanced: true,
    options: STUDIO_DIVIDER_HEIGHT_OPTIONS,
  },
];

/** Aplica as propriedades de decoração a todos os blocos já registrados. */
export function aplicarPropriedadesDeDecoracao(): void {
  listBlocks().forEach((definicao) => {
    if (definicao.props.some((p) => p.key === 'background')) return;
    registerBlock({ ...definicao, props: [...definicao.props, ...PROPRIEDADES_DE_DECORACAO] });
  });
}

aplicarPropriedadesDeDecoracao();
